<template>
<div
    class="copy-master view-outer home-view-outer pr"
    :class="{'is-fullscreen': is24Col  }"
>
  <div class="left-content">
    <top-desc
      @open-account="openAccountHandle"
    ></top-desc>
    <right-bar class="right-content"></right-bar>
    <my-mam-account-list></my-mam-account-list>
  </div>
</div>
</template>

<script>
// copyMaster页面 todo
import rightBar from "@/components/copyMaster/home/rightBar";
import myMamAccountList from "@/components/copyMaster/home/myMamAccountList";
import topDesc from "@/components/copyMaster/home/topDesc";
export default {
  name: "copyMaster",
  components: {
    topDesc,
    myMamAccountList,
    rightBar,
  },
  computed: {
    is24Col(){
      return true;
      /*if(this.language == 'zh_CN'){
        return !this.unOpenAccount;
      }else {
        if(!this.unOpenAccount && this.dynamicList.length){
          return true;
        }else {
          return false;
        }
      }*/
    }
  },
  methods: {
    openAccountHandle(strType){
      if(strType == 'master'){
        this.roleNumber = 4
      }else {
        this.roleNumber = 5;
      }
      this.$store.commit('setOpenAccountRole', this.roleNumber);
      this.$store.commit('setOpenAccountDialogShow', true);
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px){
  .home-view-outer {
    &.is-fullscreen {
      padding-right: 330px!important; // 拉扯浏览器页面窗口时,还有问题,ui重叠了在一起
      .left-content {
        .right-content {
          position: absolute;
          right: 0px;
          top: 10px;
          width: 300px;
        }
      }
    }
  }
}
.right-content {

}
</style>
